import React from "react";
import Newsletter_47 from "../component/Newsletter_47";

function Newsletter_47_container() {
  return <Newsletter_47 />;
}

export default Newsletter_47_container;
